module.exports = __webpack_public_path__ + "static/media/template-carrier.d8f9ffbf.xlsx";